import _get from 'lodash/get';
import { baseState } from '../selectors';

const getState = state => _get(baseState(state), 'resetPassword');
export const getIsSubmitting = state => _get(getState(state), 'isSubmitting');
export const getExpiredLink = state => _get(getState(state), 'expiredLink');